import { create } from 'zustand';

export const useStore = create((set) => ({
  // ────── Customer Context ──────
  restaurantId: null,
  tableId: null,
  token: null,
  tableNumber: null,
  setCustomerContext: (rid, tid, token, num) =>
    set({ restaurantId: rid, tableId: tid, token, tableNumber: num }),

  // ────── Cart with Unit Support ──────
  cart: [],

  /**
   * Add item to cart.
   * @param {Object} item - Must include: id, name, price, unit ('half'|'full'|'piece')
   */
  addToCart: (item) => set((state) => {
    const key = `${item.id}-${item.unit}`;
    const exists = state.cart.find(i => `${i.id}-${i.unit}` === key);

    if (exists) {
      return {
        cart: state.cart.map(i =>
          i.id === item.id && i.unit === item.unit
            ? { ...i, qty: i.qty + 1 }
            : i
        )
      };
    }

    return {
      cart: [...state.cart, { ...item, qty: 1, notes: '' }]
    };
  }),

  /**
   * Update quantity of a specific (id + unit) line.
   * @param {number} id
   * @param {number} qty - new quantity (0 removes)
   * @param {string} unit - 'half'|'full'|'piece'
   */
  updateQty: (id, qty, unit) => set((state) => {
    if (qty <= 0) {
      return { cart: state.cart.filter(i => !(i.id === id && i.unit === unit)) };
    }
    return {
      cart: state.cart.map(i =>
        i.id === id && i.unit === unit ? { ...i, qty } : i
      )
    };
  }),

  /**
   * Remove entire line (id + unit)
   */
  removeFromCart: (id, unit) => set((state) => ({
    cart: state.cart.filter(i => !(i.id === id && i.unit === unit))
  })),

  clearCart: () => set({ cart: [] }),

  // ────── Admin ──────
  adminAuth: null,
  setAdminAuth: (auth) => set({ adminAuth: auth }),
  logout: () => set({ adminAuth: null, restaurantId: null })
}));